// Resolves the <img> src for an asset preview at the requested derivative size.
// grid_url comes before small_url in the fallback because video small_url is an .mp4 — only grid_url is guaranteed to be an image.
export const resolveAssetImageSrc = (asset, thumbType) => {
    if(asset.type === 'Video' && thumbType === 'permalink') thumbType = 'permalink_image'
    return asset[`${thumbType}_url`] || asset.grid_url || asset.small_url
}
